import { defineMessages } from 'react-intl';

export const billingSimulationMessages = defineMessages({
    simulateBilling: {
        id: 'simulate-billing',
        defaultMessage: 'Simulate billing',
    },
    billingSimulation: {
        id: 'billing-simulation',
        defaultMessage: 'Billing simulation',
    },
    pageSubtitle: {
        id: 'billing-simulation-page-subtitle',
        defaultMessage:
            'Run a dry-run of charging and invoicing for this service plan over a date range. No data is persisted.',
    },
    backToServicePlan: {
        id: 'billing-simulation-back-to-service-plan',
        defaultMessage: 'Back to service plan',
    },
    startDate: {
        id: 'billing-simulation-start-date',
        defaultMessage: 'Start date',
    },
    endDate: {
        id: 'billing-simulation-end-date',
        defaultMessage: 'End date',
    },
    runSimulation: {
        id: 'billing-simulation-run',
        defaultMessage: 'Run simulation',
    },
    runningSimulation: {
        id: 'billing-simulation-running',
        defaultMessage: 'Running simulation…',
    },
    resultsTitle: {
        id: 'billing-simulation-results-title',
        defaultMessage: 'Simulation results',
    },
    resultsSubtitle: {
        id: 'billing-simulation-results-subtitle',
        defaultMessage: 'Period {startDate} – {endDate}',
    },
    chargesTab: {
        id: 'billing-simulation-charges-tab',
        defaultMessage: 'Charges ({count})',
    },
    financialDocumentsTab: {
        id: 'billing-simulation-financial-documents-tab',
        defaultMessage: 'Financial documents ({count})',
    },
    quantityEventsTab: {
        id: 'billing-simulation-quantity-events-tab',
        defaultMessage: 'Quantity events ({count})',
    },
    usageRecordsTab: {
        id: 'billing-simulation-usage-records-tab',
        defaultMessage: 'Usage records ({count})',
    },
    noCharges: {
        id: 'billing-simulation-no-charges',
        defaultMessage: 'No charges would be generated for this period.',
    },
    noFinancialDocuments: {
        id: 'billing-simulation-no-financial-documents',
        defaultMessage: 'No financial documents would be generated for this period.',
    },
    item: {
        id: 'billing-simulation-item',
        defaultMessage: 'Item',
    },
    type: {
        id: 'billing-simulation-type',
        defaultMessage: 'Type',
    },
    category: {
        id: 'billing-simulation-category',
        defaultMessage: 'Category',
    },
    status: {
        id: 'billing-simulation-status',
        defaultMessage: 'Status',
    },
    amount: {
        id: 'billing-simulation-amount',
        defaultMessage: 'Amount',
    },
    taxAmount: {
        id: 'billing-simulation-tax-amount',
        defaultMessage: 'Tax',
    },
    amountWithTax: {
        id: 'billing-simulation-amount-with-tax',
        defaultMessage: 'Amount with tax',
    },
    periodStart: {
        id: 'billing-simulation-period-start',
        defaultMessage: 'Period start',
    },
    periodEnd: {
        id: 'billing-simulation-period-end',
        defaultMessage: 'Period end',
    },
    documentNumber: {
        id: 'billing-simulation-document-number',
        defaultMessage: 'Number',
    },
    issueDate: {
        id: 'billing-simulation-issue-date',
        defaultMessage: 'Issue date',
    },
    dueDate: {
        id: 'billing-simulation-due-date',
        defaultMessage: 'Due date',
    },
    rows: {
        id: 'billing-simulation-rows',
        defaultMessage: 'Rows',
    },
    rowName: {
        id: 'billing-simulation-row-name',
        defaultMessage: 'Description',
    },
    quantity: {
        id: 'billing-simulation-quantity',
        defaultMessage: 'Qty',
    },
    price: {
        id: 'billing-simulation-price',
        defaultMessage: 'Price',
    },
    discountPolicies: {
        id: 'billing-simulation-discount-policies',
        defaultMessage: 'Discount policies',
    },
    discountPoliciesPlaceholder: {
        id: 'billing-simulation-discount-policies-placeholder',
        defaultMessage: 'Select discount policies to apply…',
    },
    discountPoliciesSearchPlaceholder: {
        id: 'billing-simulation-discount-policies-search',
        defaultMessage: 'Search discount policies…',
    },
    noDiscountPolicies: {
        id: 'billing-simulation-no-discount-policies',
        defaultMessage: 'No discount policies',
    },
    noDiscountPoliciesFound: {
        id: 'billing-simulation-no-discount-policies-found',
        defaultMessage: 'No matching discount policies found.',
    },
    voucherTypes: {
        id: 'billing-simulation-voucher-types',
        defaultMessage: 'Voucher types',
    },
    voucherTypesPlaceholder: {
        id: 'billing-simulation-voucher-types-placeholder',
        defaultMessage: 'Select voucher types to apply…',
    },
    voucherTypesSearchPlaceholder: {
        id: 'billing-simulation-voucher-types-search',
        defaultMessage: 'Search voucher types…',
    },
    noVoucherTypes: {
        id: 'billing-simulation-no-voucher-types',
        defaultMessage: 'No voucher types',
    },
    noVoucherTypesFound: {
        id: 'billing-simulation-no-voucher-types-found',
        defaultMessage: 'No matching voucher types found.',
    },
});
